module.exports = __webpack_public_path__ + "static/media/earthArrowLeft_disable.96766181.svg";